var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Calendar',{attrs:{"exams":_vm.exams,"holidays":_vm.holidays,"name":"schoolClassExams","allowedViews":['term'],"loading":_vm.loading},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }